import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5A378C",
      "fill-rule": "evenodd",
      d: "M34.489 0c.253 0 .458.205.458.458v7.064l4.068 2.11c.605.314.985.938.985 1.62v31.354c0 1.37-1.451 2.25-2.666 1.62L20.84 35.67a1.82 1.82 0 0 0-1.68 0L2.665 44.226c-1.215.63-2.666-.25-2.666-1.62V11.252c0-.682.38-1.306.985-1.62L19.159.205a1.83 1.83 0 0 1 1.682 0l7.021 3.642V.457c0-.252.205-.457.458-.457zM16.02 13.85h-3.446c-.267 0-.436.17-.436.437v15.86c0 .266.17.436.436.436h3.446c.267 0 .437-.17.437-.436v-5.93h7.084v5.93c0 .266.17.436.437.436h3.446c.267 0 .437-.17.437-.436v-15.86c0-.267-.17-.437-.437-.437h-3.446c-.267 0-.437.17-.437.437v5.93h-7.084v-5.93c0-.267-.17-.437-.437-.437",
      mask: "url(#a)"
    }, null, -1)
  ])))
}
export default { render: render }